export default __webpack_public_path__ + "static/media/Flag_of_Saudi_Arabia.1a53292b.svg";